import { Badge, Box, CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { BasicTable, Button } from '@components';
import { customerUrls } from '@constants/urls';
import { A } from '@solidjs/router';
import {
  customerDetailsStore,
  CustomerOutstandingOrders,
} from '@store/customers/customerDetails';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { formatAmount } from '@utils/utils';
import { size } from 'lodash';
import { DateTime } from 'luxon';

import { outstandingInvoicesClasses as classes } from './classes';

const OutstandingInvoices = () => {
  const columns = [
    {
      name: 'Order Number',
      key: 'orderId',
    },
    {
      name: 'Invoice Date',
      key: 'invoicedDate',
      renderCell: (row: CustomerOutstandingOrders) =>
        row.invoicedDate
          ? DateTime.fromISO(row.invoicedDate).toFormat('MM/dd/yyyy')
          : '',
    },
    {
      name: 'Days Elapsed',
      key: 'daysElapsed',
    },
    {
      name: 'Amount',
      key: 'amount',
      renderCell: (row: CustomerOutstandingOrders) => formatAmount(row.amount),
    },
  ];

  return (
    <CollapsibleCard
      startTitle={
        <Box>
          Outstanding Invoices
          <Badge
            badgeContent={size(customerDetailsStore.customer.outstandingOrders)}
            showZero
            max={999}
            style={{ 'margin-left': '20px' }}
            badgeStyle={{
              'background-color': '#ffffff',
              color: '#000000',
            }}
          ></Badge>
        </Box>
      }
      endTitle={
        <A
          target="_blank"
          href={customerUrls.report(customerDetailsStore.customer.id as number)}
        >
          <Button
            label="REPORT"
            class={classes.buttonClass}
            dataTestId={formatDataTestId('REPORT', 'button')}
          />
        </A>
      }
      class="mb-2"
    >
      <Box
        style={{
          height: 'auto',
          'max-height': '350px',
          'overflow-y': 'auto',
        }}
        class="[&>div>table>.MuiTableHead-root]:bg-[#f2f2f2]"
      >
        <BasicTable
          columns={columns}
          rows={customerDetailsStore.customer.outstandingOrders || []}
        />
      </Box>
    </CollapsibleCard>
  );
};

export default OutstandingInvoices;
